import { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';

import { baseUrl } from "../../api/api";
import { apiList } from '../../api/callAPI';

import * as basicConstants from '../../constants/basic';
import * as urlConstants from '../../constants/url';
import * as alertConstants from '../../constants/alertMsg';
import useUser from '../../hook/useUser';

import theme from '../../theme';

const GoogleSigninButton = (props) => {
  const history = useHistory();
  const { setUserData, setAuthStatusMsg } = useUser();

  const { handleLoginStatus } = props;

  const initClient = () => {
    window.google.accounts.id.initialize({
      client_id: baseUrl.googleClientId,
      callback: handleCredentialResponse,
      use_fedcm_for_prompt: true
    });
    window.google.accounts.id.renderButton(
      document.getElementById('buttonDiv'),
      {
        theme: 'outline',
        size: 'large',
        width: 300
      }
    );
    window.google.accounts.id.prompt();
  }

  useEffect(() => {
    const gsi = document.querySelector('#google-gsi-script');
    // const gsi = document.querySelector('#root');

    if (!window.google) {
      gsi.addEventListener('load', initClient);
    } else {
      initClient();
    };

    return () => gsi.removeEventListener('load', initClient);

  }, [])

  const handleCredentialResponse = (response) => {
    let id_token = response.credential;

    handleLoginStatus(true);

    // console.log('credential',response);
    // console.log('google token',id_token)

    apiList.apiUserGoogleLogin({
      "token": id_token
    })
      .then(res => {
        if (res?.status === 200) {
          // console.log('res', res)
          sessionStorage.setItem(basicConstants.SESSION_CREATE_TIME, Date.now());
          setUserData(res.data.result);
          history.push(urlConstants.PAGE_MEDIA_MENU);
        } else {
          setAuthStatusMsg(alertConstants.ERROR_AUTH);
          setUserData(false);
        }

        handleLoginStatus(false);
      })
      .catch(err => {
        console.error('API request failed:', err);
        setAuthStatusMsg(alertConstants.ERROR_AUTH);
        handleLoginStatus(false);
      });
  }

  return (
    <>
      <div id="buttonDiv" />
    </>
  )
}

export default GoogleSigninButton;